import type { TelegramConfig, TelegramUser } from '../lib/api.js';
import { TelegramLogin } from './TelegramLogin.js';

interface TelegramGateProps {
  config: TelegramConfig;
  onLogin: (user: TelegramUser) => void;
}

/**
 * Дверь: без входа через телеграм дальше не пускаем.
 *
 * Показывается, когда владелец сервера включил обязательный вход. Смысл
 * не в запрете ради запрета: имя и аватарка тогда у всех настоящие, и в
 * комнате видно, кто есть кто, — вместо десятка «Гостей».
 */
export function TelegramGate({ config, onLogin }: TelegramGateProps): JSX.Element {
  return (
    <main className="shell gate-screen">
      <div className="gate-screen__card card">
        <span className="gate-screen__mark" aria-hidden="true">
          🍿
        </span>

        <h1 className="card__title">Смотрим вместе</h1>
        <p className="card__lede">
          Чтобы зайти, подключите телеграм. Так в комнате видно, кто есть кто, а бот сможет
          прислать ссылку, которую вы перешлёте друзьям.
        </p>

        {config.botUsername ? (
          <TelegramLogin botUsername={config.botUsername} onLogin={onLogin} />
        ) : (
          <p className="error" role="alert">
            Вход через телеграм включён, но имя бота не задано. Это настройка сервера:
            переменная TELEGRAM_BOT_USERNAME.
          </p>
        )}

        <p className="gate-screen__note">
          Мы получаем только имя, псевдоним и аватарку. Переписку и контакты телеграм не
          отдаёт никому, включая нас.
        </p>
      </div>
    </main>
  );
}
